import type { SubTimer } from '~shared/rundown/cue'
import { newFirestoreId } from '~shared/utils'

export type {
  SubTimer,
  SubTimerDirection,
  SubTimerEndAction,
} from '~shared/rundown/cue'

/** What the add/edit form produces. The id is assigned on create. */
export type SubTimerInput = Omit<SubTimer, 'id'>

export function createSubTimer(input: SubTimerInput): SubTimer {
  return { id: newFirestoreId(), ...input }
}

export type DropSide = 'before' | 'after'

/** The ids in their new order, or null when the drop changes nothing. */
export function reorderIds(
  ids: readonly string[],
  activeId: string,
  target: { timerId: string; side: DropSide },
): string[] | null {
  if (activeId === target.timerId) return null
  const rest = ids.filter((id) => id !== activeId)
  const at = rest.indexOf(target.timerId)
  if (at === -1) return null
  const next = [...rest]
  next.splice(target.side === 'before' ? at : at + 1, 0, activeId)
  return next.every((id, i) => id === ids[i]) ? null : next
}
